import React from 'react';
import isArray from 'lodash/isArray';
import { useDispatch } from 'react-redux';

import { openUploadedFile, downloadUploadedFile, downloadUploadedVoucherFile, openUploadedVoucherFile } from 'store/forms/actions';
import { ReactComponent as FileExcel } from 'assets/icons/excel_icon.gov.svg';
import { ReactComponent as FileWord } from 'assets/icons/word_icon.gov.svg';
import { ReactComponent as FilePdf } from 'assets/icons/pdf_icon.gov.svg';
import { ReactComponent as FileImage } from 'assets/icons/image_icon.gov.svg';
import { ReactComponent as DownloadIcon } from 'assets/icons/download_blue.svg';

import { getFullIsoDate } from 'utils';
import { isNil } from 'lodash';
import { useSelector } from 'react-redux';

const Download = ({ description, file, simple = false, voucherAuditor = false, voucherViewer = false }) => {
const groups = useSelector(state => state.user.groups);
  const certifications = useSelector(state => state.forms.documents.certification);
  const dispatch = useDispatch();
  const renderIcon = type => {
    switch (type) {
      case 'pdf':
        return <FilePdf />;
      case 'PDF':
        return <FilePdf />;
      case 'excel':
        return <FileExcel />;
      case 'JPEG':
        return <FileImage />;
      case 'PNG':
        return <FileImage />;
      default:
        return <FileWord />;
    }
  };

  return isArray(file)
    ? file.map((f, index) => (
        <div key={index} className={`download-file`}>
          {index === 0 && (
            <div className="download-file__title">{description}</div>
          )}
          <div className="d-flex justif-content-between">
            <div className="w-100 d-flex align-items-center">
              {renderIcon(f.simpleType ?? f.fileType)}
              <div className="download-file__details">
                <div className="filename">{f.name ?? f.fileName}</div>
                <div className="filesize">
                  {Math.round(f.size / 1000)} KB
                  {f.created && <span className="filesize">
                    {' '}
                    Updated: {getFullIsoDate(f.created)}
                  </span>}
                  
                </div>
                {f.field=="certificationDocs" && !isNil(certifications) &&
                    
                    (<div>
                      <span className="meta-tag mr-1"><span className="bold">Πιστοποίηση </span> {certifications[index].certification} </span>
                      <span className="meta-tag mr-1"> <span className="bold">Φορέας </span>{certifications[index].certificationCarrier} </span>
                      <span className="meta-tag"><span className="bold">Τρόπος </span>{certifications[index].certificationType} </span>
                      </div>)}
              </div>
            </div>
            <div className= {f.field=="certificationDocs" ? "d-flex mt-test" : "d-flex"} >
              <div
                className="open-file"
                onClick={() =>
                  dispatch(
                    (f.simpleType === 'pdf' || f.fileType === 'PDF')
                      ? simple ? openUploadedVoucherFile(f, groups, voucherAuditor) : openUploadedFile(f)
                      : simple ? downloadUploadedVoucherFile(f, groups, voucherAuditor) : downloadUploadedFile(f)
                  )
                }
              >
                Άνοιγμα
              </div>  
              <div
                className="d-flex"
                onClick={() => dispatch(simple ? downloadUploadedVoucherFile(f, groups, voucherAuditor) : downloadUploadedFile(f))}
              >
                <DownloadIcon className="download-file__icon" />
                <div className="download-label">Download</div>
              </div>
            </div>
          </div>
        </div>
      ))
    : null;
};

export default Download;
